export const currentAsset = [
  {
    id: 1,

    description: 'Property, plant and equipment',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 2,

    description: 'Deferred tax assets',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 3,

    description: 'Investment',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 4,

    description: 'Other receivables',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 5,

    description: 'Invangible assets and goods',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 6,

    description: 'Biological Asset',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 7,

    description: 'Investment Property',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 8,

    description: 'Income',
    value: 33200,
    itemCount: 40,
  },
  {
    id: 9,

    description: 'Expenditure',
    value: 33200,
    itemCount: 40,
  },
];
export const NoncurrentAsset = [
  {
    id: 1,
    country: 'Canada',
    soldBy: 'Bill',
    client: 'Cerberus Corp.',
    description: 'Prothean artifacts',
    value: 6250,
    itemCount: 50,
  },
];
export const info = [
  {
    id: 1,
    name: 'Abdul Fuller',
    phone: '1-280-847-1510',
    email: 'ut@protonmail.com',
    country: 'Costa Rica',
    alphanumeric: 'BBX73IXM2UO',
  },

  {
    id: 3,
    name: 'Shelly Lucas',
    phone: '1-244-417-0372',
    email: 'adipiscing.lobortis.risus@aol.ca',
    country: 'Austria',
    alphanumeric: 'MIX67LDV4VC',
  },
];
